import { SxProps, Theme } from "@mui/material/styles";

const ACCENT_PURPLE = "#7B49C1";
const ACCENT_PURPLE_LIGHT = "#C4B5FD";

export const playerRowStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  mt: 0.75,
};

export const getPlayButtonStyles = (
  variant: "user" | "assistant" = "assistant",
): SxProps<Theme> => (theme) => {
  const isDark = theme.palette.mode === "dark";
  const isUser = variant === "user";

  if (isDark && isUser) {
    return {
      color: "#FFFFFF",
      backgroundColor: "rgba(255, 255, 255, 0.18)",
      border: "1px solid rgba(255, 255, 255, 0.28)",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.28)",
      },
      "&.Mui-disabled": {
        color: "rgba(255,255,255,0.45)",
        borderColor: "rgba(255,255,255,0.15)",
      },
    };
  }

  return {
    color: isDark ? ACCENT_PURPLE_LIGHT : ACCENT_PURPLE,
    backgroundColor: isDark
      ? "rgba(196, 181, 253, 0.16)"
      : "rgba(123, 73, 193, 0.1)",
    border: isDark ? "1px solid rgba(196, 181, 253, 0.35)" : "none",
    "&:hover": {
      backgroundColor: isDark
        ? "rgba(196, 181, 253, 0.26)"
        : "rgba(123, 73, 193, 0.18)",
    },
  };
};

export const getPlayerLabelStyles = (
  variant: "user" | "assistant" = "assistant",
): SxProps<Theme> => (theme) => ({
  color:
    theme.palette.mode === "dark" && variant === "user"
      ? "rgba(243, 244, 246, 0.88)"
      : theme.palette.text.secondary,
  fontWeight: 500,
});

export const getLoaderColor = (theme: Theme, variant: "user" | "assistant") => {
  if (theme.palette.mode === "dark" && variant === "user") return "#FFFFFF";
  if (theme.palette.mode === "dark") return ACCENT_PURPLE_LIGHT;
  return ACCENT_PURPLE;
};
